import { render, staticRenderFns } from "./weChatBase.vue?vue&type=template&id=54d31920&scoped=true"
import script from "./weChatBase.vue?vue&type=script&lang=js"
export * from "./weChatBase.vue?vue&type=script&lang=js"
import style0 from "./weChatBase.vue?vue&type=style&index=0&id=54d31920&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d31920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d31920')) {
      api.createRecord('54d31920', component.options)
    } else {
      api.reload('54d31920', component.options)
    }
    module.hot.accept("./weChatBase.vue?vue&type=template&id=54d31920&scoped=true", function () {
      api.rerender('54d31920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/weChatBase.vue"
export default component.exports